import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";

const PlanogramDataGrid = ({ rowData }) => {
  const columns = [
    {
      field: "logger_name",
      headerName: "Description",
      flex: 1.2,
      align: "left",
      headerAlign: "left",
      sortable: false,
    },
    {
      field: "logger_type",
      headerName: "Action",
      flex: 1.2,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "createdate",
      headerName: "Date",
      flex: 1.2,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },
  ];

  const [data, setData] = useState([]);
  const newArr = rowData.map((obj) => {
    const date = new Date(obj.createdate);
    const newdate = date.toLocaleString();
    return { ...obj, createdate: newdate };
  });

  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }
  return (
    <Box
      sx={{
        height: "445px",
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: "800",
          fontSize: "16px",
        },
      }}
    >
      <DataGrid
        rows={newArr}
        columns={columns}
        getRowId={(row) => generateRandom()}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 6,
            },
          },
        }}
        pageSizeOptions={[6]}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default PlanogramDataGrid;
